export default "__VITE_ASSET__35O7DsEa__"